import { SET_REQUEST_RESET_PASSWORD_ERROR } from './constant'
import { MutationTree } from 'vuex'
import { UserState } from './types'

export const mutations: MutationTree<UserState> = {
  [SET_REQUEST_RESET_PASSWORD_ERROR](state, requestResetPasswordError: boolean) {
    state.requestResetPasswordError = requestResetPasswordError
  }
}
